import { FC } from 'react';
import Text from '@deprecated-ui/common/Text';
import { iModal } from '../types';
import { ContentWrapper, HeaderWrapper, Modal } from '../DetailModal/styled';

interface InfoItem {
  title: string;
  description: string;
}

interface HistoryFeeModalProps extends iModal {
  title?: string;
  description?: string;
  info?: InfoItem[];
}

const HistoryFeeModal: FC<HistoryFeeModalProps> = ({
  visible,
  onCancel,
  title = 'Pajak Keuntungan',
  description = 'Pajak Keuntungan adalah pajak yang dikenakan atas capital gain yang diterima dari penjualan FR bonds disaat bond maturity (10%).',
}) => (
  <Modal
    visible={visible}
    onCancel={onCancel}
    centered
    width={520}
    data-cy="trade-detail-modal-container"
  >
    <HeaderWrapper>
      <Text align="center" family="bold" size="20px">
        {title}
      </Text>
    </HeaderWrapper>
    <ContentWrapper>
      <Text>{description}</Text>
    </ContentWrapper>
  </Modal>
);

export default HistoryFeeModal;
